export default "__VITE_ASSET__7002fb6b__"